export default {
  // 배송전
  BEFORE_SHIP: 'F',
  // 배송중
  SHIP_ING: 'M',
  // 배송 완료
  SHIP_FINISHED: 'T',
  // 배송 보류
  SHIP_DELAYED: 'W'
}



// WEBPACK FOOTER //
// ./src/components/menus/cafe24/enums/ShipmentType.js